
const ChemicalSupply = () => {
  const supplyCategories = [
    {
      category: "Production Chemicals",
      description: "Essential chemicals for optimizing oil and gas production operations",
      icon: "ri-oil-line",
      chemicals: [
        "Corrosion inhibitors",
        "Scale inhibitors", 
        "Biocides",
        "Demulsifiers",
        "Foam control agents",
        "Paraffin inhibitors"
      ]
    },
    {
      category: "Drilling & Completion",
      description: "Specialized chemicals for drilling operations and well completion",
      icon: "ri-tools-line",
      chemicals: [
        "Drilling fluid additives",
        "Lost circulation materials",
        "Completion fluids",
        "Cement additives",
        "Filtration control agents",
        "Rheology modifiers"
      ]
    },
    {
      category: "Stimulation Chemicals",
      description: "Advanced chemicals for well stimulation and productivity enhancement",
      icon: "ri-pulse-line",
      chemicals: [
        "Acid systems (HCl, HF)",
        "Acid additives",
        "Diverting agents",
        "Surfactants",
        "Clay stabilizers",
        "Iron control agents"
      ]
    },
    {
      category: "Water Treatment",
      description: "Comprehensive solutions for water management and treatment",
      icon: "ri-drop-line",
      chemicals: [
        "Oxygen scavengers",
        "pH adjusters",
        "Flocculants",
        "Coagulants",
        "Antiscalants",
        "Disinfectants"
      ]
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Chemical Supply & Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Golden Black maintains extensive inventory of high-quality chemicals, 
            ensuring reliable supply for all your oilfield operations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {supplyCategories.map((category, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                  <i className={`${category.icon} text-2xl text-teal-600`}></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">{category.category}</h3>
                  <p className="text-gray-600 mt-1">{category.description}</p>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-3">
                {category.chemicals.map((chemical, chemIndex) => (
                  <div key={chemIndex} className="flex items-center">
                    <i className="ri-check-line text-teal-600 mr-2 text-sm"></i>
                    <span className="text-gray-700 text-sm">{chemical}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-xl shadow-lg p-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Quality Assurance & Logistics
            </h3>
            <p className="text-gray-600 mb-8 max-w-3xl mx-auto">
              All chemicals are sourced from certified manufacturers and undergo rigorous quality control. 
              Our logistics network ensures timely delivery across the UAE and regional markets.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-award-line text-2xl text-teal-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">ISO Certified Quality</h4>
                <p className="text-gray-600 text-sm">All products meet international quality standards</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-2xl text-teal-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Fast Delivery</h4>
                <p className="text-gray-600 text-sm">24-48 hour delivery across UAE</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-customer-service-2-line text-2xl text-teal-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Technical Support</h4>
                <p className="text-gray-600 text-sm">Expert guidance for optimal chemical selection</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChemicalSupply;
